export const footerLinks = [
  { title: "Deportes", link: "/sports" },
  { title: "Instituciones", link: "/institutions" },
  { title: "Planes", link: "/plans" },
  // { title: "Ayuda", link: "/help" },
];
